/* eslint-disable import/max-dependencies */
import type { FC } from "react";
import React from "react";
import { Helmet } from "react-helmet";
import { SetupCard, withHookPropsState } from "@fas/cpa-cabinet-ui";
import TabsSwitcher from "@fas/cpa-cabinet-ui/lib/TabsSwitcher";
import { withStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { setupCardStyles } from "../../styles";
import {
  MAIN_REPORT_TABLE,
  REPORTS_PAGE,
  TRANSACTION_REPORT_TABLE,
} from "../../constants";
import { useConfigureReport, useTabs } from "../../hooks";
import ConfigureMainReport from "../ConfigureMainReport";
import ConfigureTransactionReport from "../ConfigureTransactionReport";
import Report from "../Report";
import { transactionReportColumnsMap } from "./transactionReportColumnsMap";
import { mainReportColumnsMap } from "./mainReportColumnsMap";
import AdditionalTabButton from "./AdditionalTabButton";
import { useExportReport } from "../../hooks/useExportReport";
import TotalMain from "./TotalMain";
import TotalTransaction from "./TotalTransaction";
import reportTableMainTotal from "../../styles/reportTableMainTotal";
import reportTableTotalTransaction from "../../styles/reportTableTotalTransaction";
import InfoMainPopup from "./InfoMainPopup";
import tabsSwitcher from "../../styles/tabsSwitcher";

const StyledSetupCard = withStyles(setupCardStyles)(SetupCard);
const StyledTotalMain = withStyles(reportTableMainTotal)(TotalMain);
const StyledTotalTransaction = withStyles(reportTableTotalTransaction)(
  TotalTransaction
);
const StyledTabs = withStyles(tabsSwitcher)(
  TabsSwitcher
) as typeof TabsSwitcher;
const Tabs = withHookPropsState(StyledTabs, useTabs);
const ConfigureMainReportComponent = withHookPropsState(
  ConfigureMainReport,
  useConfigureReport
);
const ConfigureTransactionReportComponent = withHookPropsState(
  ConfigureTransactionReport,
  useConfigureReport
);
export const paramsToComponents = {
  main: () => (
    <>
      <Helmet>
        <title>
          Main report
        </title>
      </Helmet>
      <Report
        headerTotal={<InfoMainPopup />}
        bodyTotal={<StyledTotalMain />}
        tableKey={MAIN_REPORT_TABLE}
        columnsMap={mainReportColumnsMap}
        configureComponent={
          <ConfigureMainReportComponent
            hookProps={{
              tableKey: MAIN_REPORT_TABLE,
            }}
          />
        }
      />
    </>
  ),
  transaction: () => (
    <>
      <Helmet>
        <title>
          Transaction report
        </title>
      </Helmet>
      <Report
        footerTotal={<StyledTotalTransaction />}
        tableKey={TRANSACTION_REPORT_TABLE}
        columnsMap={transactionReportColumnsMap}
        configureComponent={
          <ConfigureTransactionReportComponent
            hookProps={{
              tableKey: TRANSACTION_REPORT_TABLE,
            }}
          />
        }
      />
    </>
  ),
};
const ExportButton = withHookPropsState(AdditionalTabButton, useExportReport);

type Props = {
  param: keyof typeof paramsToComponents;
};
const Reports: FC<Props> = ({ param }) => (
  <StyledSetupCard title="Statistics">
    <Box display="flex">
      <Box flexGrow={1} minWidth={0}>
        <Tabs
          hookProps={{
            key: REPORTS_PAGE,
          }}
        />
      </Box>
      <ExportButton hookProps={param}>
        Export report
      </ExportButton>
    </Box>
    {paramsToComponents[param]?.()}
  </StyledSetupCard>
);

export default Reports;
